import { IMiddleware, Middleware, StopAction } from '@tencent/workbench';
import type { IStopAction } from '@tencent/workbench';
import { i18n } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { isWebGLEnabled } from '@src/slide/infrastructure/module/dependent/3d/webgl';

/**
 * 3d 被禁用时提示用户 disabled workbench tooltip
 */
@Middleware()
export class ThreeDDisabledTooltipMiddleware implements IMiddleware {
    public use(@StopAction() stop: IStopAction) {
        if (!isWebGLEnabled()) {
            stop();
            return i18n.t('浏览器硬件加速已关闭，暂时无法使用三维形状功能。');
        }
    }
}
